/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_Choices_HintInputs */

const en_admin_questionnaire_editor_choices_hint = /** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Members will be able to select choices. Add one choice per line.`)
};

const nl_admin_questionnaire_editor_choices_hint = /** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leden kunnen keuzes selecteren. Voeg één keuze per regel toe.`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const de_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const es_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const it_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/** @type {(inputs: Admin_Questionnaire_Editor_Choices_HintInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_choices_hint = en_admin_questionnaire_editor_choices_hint;

/**
* | output |
* | --- |
* | "Members will be able to select choices. Add one choice per line." |
*
* @param {Admin_Questionnaire_Editor_Choices_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_choices_hint = /** @type {((inputs?: Admin_Questionnaire_Editor_Choices_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_Choices_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "nl") return nl_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_choices_hint(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_choices_hint(inputs)
	return ro_admin_questionnaire_editor_choices_hint(inputs)
});
export { admin_questionnaire_editor_choices_hint as "admin.questionnaire_editor.choices_hint" }